export default __webpack_public_path__ + "static/media/past-work-outline-16px.c5706ebb.svg";